import { Component, ElementRef, EventEmitter, Input, Output, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-circular-selection',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './circular-selection.component.html',
  styleUrls: ['./circular-selection.component.scss']
})
export class CircularSelectionComponent {

  @Output() onClickAction = new EventEmitter<any>();
  @Input() scrollableDiv!: ElementRef<HTMLDivElement>
  @Input() highlightText!: ElementRef<HTMLDivElement>
  @Input() options!: any[];
  @Input() showBackBtn = true
  @Input() config = {
    animation: true,
    selectionType: 'single',
    selectionLimit:1
  }

  constructor(private renderer: Renderer2){}

  navigateBack(): void {
    this.onClickAction.emit({ action: 'back' })
  }

  optionSelected(data: any): void {
    if (this.config.selectionType === 'single')
      this.onClickAction.emit({ action: 'selected', data: data })

    if (this.config.selectionType === 'multi') {
      const selected = this.options.filter((x: any) => x.isSelected)
      if (!data.isSelected && selected.length >= this.config.selectionLimit){
        this.scrollToSubHeading();
        return;
      }
      data.isSelected = !data.isSelected
      this.onClickAction.emit({ action: 'selected', data: this.options.filter((x: any) => x.isSelected) })

    }
  }

  scrollToSubHeading() {
    if (this.highlightText) {
      const offset = 100;
      const elementPosition = this.scrollableDiv.nativeElement.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
      const event = new CustomEvent('scrollToSubHeadingEvent', { detail: { calledFrom: 'circularSelection' } });
      window.dispatchEvent(event);

      this.renderer.setStyle(this.highlightText.nativeElement, 'backgroundColor', 'yellow');
      setTimeout(() => {
        this.renderer.removeStyle(this.highlightText.nativeElement, 'backgroundColor');
      }, 10000);
    }
  }
}
